<template>
  <view class="swiper-container">
    <block wx:if="{{banners && banners.length}}">
      <block wx:if="{{banners && banners.length ===1}}">
        <block wx:for="{{banners}}">
          <image
            class="swiper-box-item-image"
            src="{{item.url}}"
            bindtap="bannerClickHandle(item)"
            mode="aspectFill"
          />
        </block>
      </block>
      <block wx:else>
        <swiper
          class="swiper-box"
          autoplay
          circular
          current="{{0}}"
          interval="{{3000}}"
          bindchange="handleIndexChange"
        >
          <swiper-item class="swiper-box-item" wx:for="{{banners}}" wx:key="index">
            <image
              class="swiper-box-item-image"
              src="{{item.url}}"
              bindtap="bannerClickHandle(item)"
              mode="aspectFill"
            />
          </swiper-item>
        </swiper>
      </block>
      <!-- 面板指示点 -->
      <view wx:if="{{banners && banners.length > 1}}" class="dots">
        <view
          wx:for="{{banners}}"
          wx:key="index"
          wx:class="dot-item {{ currentKey === index ? 'active' : '' }}"
        ></view>
      </view>
    </block>
  </view>
</template>


<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { goTo } from '@didi/webx-js'
  import { isWXMini, isALIMini } from '@/common/constant'
  import store from '@/store'

  createComponent({
    props: {
      currentProd: {
        type: String,
        value: ''
      }
    },
    data: {
      currentKey: 0
    },
    computed: {
      ...store.mapState({
        trainBannerData: 'coupon.trainBannerData',
        homeApolloData: 'common.homeApolloData'
      }),
      isMiniH5() {
        return isWXMini || isALIMini
      },
      trainBanners() {
        return this.trainBannerData.length ? this.trainBannerData : []
      },
      flightsBanner() {
        const { flights_banner_config = [] } = this.homeApolloData || {}
        const flightsConfig = flights_banner_config.length
          ? flights_banner_config
          : [
              {
                url: 'https://ut-static.udache.com/webx/sfc/mEcV1fM4YA91ZN-bgdB2S.jpg'
              }
            ]
        return flightsConfig
      },
      banners() {
        return this.currentProd === 'train' ? this.trainBanners : this.flightsBanner
      }
    },
    methods: {
      bannerClickHandle(item) {
        const { toUrl, toUrlMiniH5, xak } = item
        const url = xak ? toUrl : this.isMiniH5 ? toUrlMiniH5 : toUrl
        url && goTo({ url: url })
      },
      handleIndexChange({ detail }) {
        this.currentKey = detail.current
      }
    }
  })
</script>


<style lang="stylus" scoped>
  .max-size
    width 100%
    height 100%
  .swiper-container
    position relative
    background #ff6400
    @extend .max-size
    .swiper-box
      @extend .max-size
      &-item
        @extend .max-size
        &-image
          @extend .max-size
    .dots
      width 100%
      display flex
      justify-content center
      position absolute
      bottom 83px
      pointer-events none
      .dot-item
        width 3px
        height 2px
        opacity 0.7
        background #fff
        border-radius 2px
        margin-right 2px
        transition all 200ms
      .active
        width 6px
        height 2px
        background #fff
        opacity 1
        border-radius 2px
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>